import React from 'react';
import { StatusTip } from 'tea-component';

export default (props: any) => {
  const { children, loading = true } = props;
  return loading ? (
    <StatusTip
      loadingText=""
      style={{ marginLeft: '48%', position: 'relative', top: 180 }}
      status="loading"
    />
  ) : children ? (
    children
  ) : null;
};
